import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {TabsComponent} from "./tabs.component";
import {TranslateModule} from "@ngx-translate/core";
import {ComponentsModule} from "../../components/components.module";

@NgModule({
    declarations: [
        TabsComponent
    ],
    imports: [
        CommonModule,
        TranslateModule,
        ComponentsModule
    ],
    exports: [
        TabsComponent
    ]
})
export class TabsModule {
}
